import Modal from 'react-bootstrap/Modal';
import { Link } from 'react-router-dom';
import { useWishlist } from '@providers';
import { useTranslation } from 'react-i18next';

export const WishlistModal = () => {
  const { t } = useTranslation();

  const { wishlistModalProperty, hideWishlistModal } = useWishlist();
  const propertyTitle = `${wishlistModalProperty?.subCategory}, ${wishlistModalProperty?.area}`;

  return (
    <Modal
      show={!!wishlistModalProperty}
      onHide={hideWishlistModal}
      className='ltn__modal-area ltn__add-to-cart-modal-area'
    >
      <Modal.Header>
        <button
          type='button'
          className='close'
          aria-label='Close'
          onClick={hideWishlistModal}
        >
          <span aria-hidden='true'>&times;</span>
        </button>
      </Modal.Header>
      <Modal.Body>
        <div className='ltn__quick-view-modal-inner'>
          <div className='modal-product-item'>
            <div className='row'>
              <div className='col-12'>
                <div className='modal-product-img'>
                  <img
                    src={wishlistModalProperty?.mainImages[0]?.thumbUrl}
                    alt={propertyTitle}
                  />
                </div>
                <div className='modal-product-info'>
                  <h5>
                    <Link to='/property'>{propertyTitle}</Link>
                  </h5>
                  <p className='added-cart'>
                    <i className='fa fa-check-circle'></i>
                    {t('wishlistModal.successfullyAdded')}
                  </p>
                  <div className='btn-wrapper'>
                    <Link
                      to='/wishlist'
                      className='theme-btn-1 btn btn-effect-1'
                      onClick={hideWishlistModal}
                    >
                      {t('wishlistModal.viewWishlist')}
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};
